/* Sneaker Ask-stijl productkaarten: puntjes volgen de swipe, pijltjes op desktop,
   paarse winkelmand opent de bestaande "Snel toevoegen"-lade. Markup: snippets/sa-card-media.liquid */
(function () {
  'use strict';

  if (window.__saCardInit) return;
  window.__saCardInit = true;

  function currentIndex(track) {
    var width = track.clientWidth || 1;
    return Math.round(track.scrollLeft / width);
  }

  function update(media) {
    var track = media.querySelector('[data-sa-track]');
    if (!track) return;

    var dots = media.querySelectorAll('[data-sa-dot]');
    var index = Math.max(0, Math.min(currentIndex(track), dots.length - 1));

    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === index);
    }

    var prev = media.querySelector('[data-sa-prev]');
    var next = media.querySelector('[data-sa-next]');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= dots.length - 1;
  }

  function goTo(media, index) {
    var track = media.querySelector('[data-sa-track]');
    if (!track) return;
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  }

  // scroll-events borrelen niet op, dus luisteren in de capture-fase
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track || !track.matches || !track.matches('[data-sa-track]')) return;

    var media = track.closest('[data-sa-media]');
    if (!media || media._saFrame) return;

    media._saFrame = window.requestAnimationFrame(function () {
      media._saFrame = 0;
      update(media);
    });
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var cartButton = event.target.closest('[data-sa-quick-add]');
    if (cartButton) {
      event.preventDefault();
      var card = cartButton.closest('.ProductItem');
      var trigger = card && card.querySelector('[data-quick-add-open]');

      if (trigger) {
        // na deze klik uitvoeren, zodat "klik buiten de lade"-handlers de lade niet direct sluiten
        setTimeout(function () { trigger.click(); }, 0);
      } else if (cartButton.getAttribute('data-href')) {
        window.location.href = cartButton.getAttribute('data-href');
      }
      return;
    }

    var arrow = event.target.closest('[data-sa-prev], [data-sa-next]');
    if (arrow) {
      event.preventDefault();
      var media = arrow.closest('[data-sa-media]');
      var track = media && media.querySelector('[data-sa-track]');
      if (!track) return;

      var step = arrow.hasAttribute('data-sa-next') ? 1 : -1;
      goTo(media, currentIndex(track) + step);
    }
  });

  // Automatisch doorladen op collectiepagina's, zoals Sneaker Ask: de volgende pagina wordt opgehaald
  // zodra je het einde van het grid nadert. De paginanummers blijven in de HTML (voor Google), maar onzichtbaar.
  function initInfiniteScroll() {
    var grid = document.querySelector('[data-collection-grid]');
    if (!grid || grid._saInfinite || !('IntersectionObserver' in window) || !window.fetch) return;

    var pagination = document.querySelector('.Pagination');
    var nextLink = pagination && pagination.querySelector('a[rel="next"]');
    if (!nextLink) return;

    grid._saInfinite = true;
    var nextUrl = nextLink.href;
    var loading = false;

    var sentinel = document.createElement('div');
    sentinel.className = 'sa-infinite';
    sentinel.innerHTML = '<span class="sa-infinite__spinner" aria-hidden="true"></span>';
    pagination.parentNode.insertBefore(sentinel, pagination);
    pagination.classList.add('sa-pagination--auto');

    function stop() {
      observer.disconnect();
      sentinel.remove();
    }

    function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      sentinel.classList.add('is-loading');

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-collection-grid]');
          var fragment = document.createDocumentFragment();

          if (newGrid) {
            Array.prototype.forEach.call(newGrid.children, function (item) {
              // de stylesheet en dit script staan al op de pagina
              Array.prototype.forEach.call(item.querySelectorAll('script, link'), function (node) { node.remove(); });
              fragment.appendChild(document.importNode(item, true));
            });
          }
          grid.appendChild(fragment);

          var newNext = doc.querySelector('.Pagination a[rel="next"]');
          nextUrl = newNext ? new URL(newNext.getAttribute('href'), window.location.href).href : null;
          loading = false;
          sentinel.classList.remove('is-loading');
          if (!nextUrl) stop();
        })
        .catch(function () {
          // bij een fout: gewoon de paginanummers weer tonen
          loading = false;
          stop();
          pagination.classList.remove('sa-pagination--auto');
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadNext();
    }, { rootMargin: '0px 0px 900px 0px' });
    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }

  // nieuwe kleur gekozen: de eerste foto wisselt, dus terug naar foto 1
  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || !radio.matches || !radio.matches('.ColorSwatch__Radio')) return;

    var card = radio.closest('.ProductItem');
    var media = card && card.querySelector('[data-sa-media]');
    if (media) goTo(media, 0);
  });
})();
